const getSortedColors = ({
  settings,
  highestFirst,
}) => Object
  .keys(settings)
  .map(key => ({
    id: key,
    threshold: settings[key],
  }))
  .sort((a, b) => {
    if(a.threshold > b.threshold) return highestFirst ? -1 : 1
    else if(a.threshold < b.threshold) return highestFirst ? 1 : -1
    else return 0
  })

const getColor = ({
  settings,
  threshold,
}) => {
  // sort the colors into highest first
  const colors = getSortedColors({
    settings,
    highestFirst: true,
  })
  // find the first color that the threshold is above
  const color = colors.find(c => threshold >= c.threshold)
  return color ? color.id : colors[colors.length-1].id
}

const getRanges = ({
  settings,
}) => {
  const colors = getSortedColors({
    settings,
  })
  return colors.map((color, i) => {
    const nextColor = colors[i+1]
    const range = {}
    if(i == 0) {
      range.min = 0
      range.max = nextColor.threshold - 1
    }
    else if(i == colors.length - 1) {
      range.min = color.threshold
      range.max = 100
    }
    else {
      range.min = color.threshold
      range.max = nextColor.threshold - 1
    }
    return Object.assign({}, color, range)
  })
}

export default {
  getColor,
  getRanges,
}